module.exports = __webpack_public_path__ + "assets/img/1301587607051_.pic_hd.7e3ae2c1.jpg";